import { useState } from "react";

export default function InputPanel({ inputText, setInputText, apiKey, onSaveKey, onGenerate, loading, error }) {
  const [showKey, setShowKey] = useState(false);
  const [localKey, setLocalKey] = useState(apiKey);
  const [keySaved, setKeySaved] = useState(false);

  const handleSave = () => {
    onSaveKey(localKey);
    setKeySaved(true);
    setTimeout(() => setKeySaved(false), 2000);
  };

  const examples = [
    "Managed a team of engineers and worked on backend systems for our main product. Helped reduce some server issues and improved the deployment process.",
    "Created marketing content and ran social media campaigns. Increased followers and helped with email newsletters.",
    "Built features for the mobile app. Fixed bugs and worked with designers to improve UI.",
  ];

  const loadExample = () => {
    const r = examples[Math.floor(Math.random() * examples.length)];
    setInputText(r);
  };

  return (
    <div className="panel input-panel">
      <div className="panel-header">
        <h2 className="panel-title">
          <span className="panel-num">01</span> Your Experience
        </h2>
        <button className="btn-ghost" onClick={loadExample}>Load Example</button>
      </div>

      <textarea
        className="textarea"
        placeholder="Paste your raw job description, experience notes, or any work you've done. Don't worry about formatting — just describe what you did in plain language."
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        rows={8}
      />

      <div className="char-count">{inputText.length} characters</div>

      <div className="api-section">
        <label className="api-label">
          🔑 OpenAI API Key
          <span className="api-hint">Stored locally, never sent to any server</span>
        </label>
        <div className="api-row">
          <input
            type={showKey ? "text" : "password"}
            className="api-input"
            placeholder="sk-..."
            value={localKey}
            onChange={(e) => setLocalKey(e.target.value)}
          />
          <button className="btn-icon" onClick={() => setShowKey(!showKey)} title="Toggle visibility">
            {showKey ? "🙈" : "👁️"}
          </button>
          <button className="btn-save" onClick={handleSave}>
            {keySaved ? "✓ Saved" : "Save"}
          </button>
        </div>
        <p className="api-note">
          Get your API key at{" "}
          <a href="https://platform.openai.com/api-keys" target="_blank" rel="noreferrer">
            platform.openai.com
          </a>
        </p>
      </div>

      {error && <div className="error-box">⚠️ {error}</div>}

      <button
        className={`btn-generate ${loading ? "loading" : ""}`}
        onClick={onGenerate}
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="spinner" /> Generating Bullets...
          </>
        ) : (
          <>
            ✨ Generate Resume Bullets
          </>
        )}
      </button>
    </div>
  );
}
